import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from "@/plugins/vuetify"
import * as Sentry from '@sentry/vue'

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://3efba7d232ffadfd3c02969b65d72135@o4505901301760000.ingest.sentry.io/4505901431980032",
    integrations: [
        new Sentry.BrowserTracing({
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(router)

app.use(vuetify)

app.mount('#app')